
import React from 'react';
import { Button } from '@/components/ui/button';

interface VerificationControlsProps {
  verificationNeeded: boolean;
  handleResendVerification: () => Promise<void>;
  resendLoading: boolean;
}

const VerificationControls: React.FC<VerificationControlsProps> = ({ 
  verificationNeeded, 
  handleResendVerification, 
  resendLoading 
}) => {
  if (!verificationNeeded) return null;
  
  return (
    <Button
      type="button"
      variant="outline"
      className="w-full"
      onClick={handleResendVerification}
      disabled={resendLoading}
    >
      {resendLoading ? "Sending..." : "Resend Verification Email"}
    </Button>
  );
};

export default VerificationControls;
